// extracted by mini-css-extract-plugin
export default {"data":"Data_data__rmyuT","content":"Data_content__RguMu"};